import FacultyDirectoryListing from "./FacultyDirectoryListing.jsx";
import ReactDom from "react-dom";

export default function renderFacultyDirectoryListing() {
  document
    .querySelectorAll(".js-faculty-directory-listing-mount")
    .forEach((mount, i) => {
      const dataModel = JSON.parse(mount.dataset.model);
      const dataQuery = JSON.parse(mount.dataset.query);
      const dataStorybook = mount.dataset.storybook
        ? JSON.parse(mount.dataset.storybook)
        : false;

      ReactDom.render(
        <FacultyDirectoryListing
          index={i}
          dataModel={dataModel}
          dataQuery={dataQuery}
          storybook={dataStorybook}
        />,
        mount,
      );
    });
}
